// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"2028a83bada25e7c5938","293":"0ca3d90df25be124e54d","454":"c2507243d08deaac3af5"}[chunkId] + ".js";
};